// Copyright (C) 2016 Comcast Corporation, All Rights Reserved

/**
 * @function Callback
 */

function onLoad()
{
    window.onerror = function( message, url, line, col, error )
    {
        var retval;

        if( error && error.stack )
            retval = error.stack;
        else
            retval = message + " at " + line + ":" + col + " of " + url;

        if( _x2._splunk )
            _x2._splunk.sendGeneralError( retval, "TVAPP-00100" );
    };
    window.contentLoadTime = new Date().getTime();
    console.log("Actual app script loaded in", (window.contentLoadTime - window.appStartTime)/1000, " secs");
    window._x2 = new X2();
    //Since we have load all libraries file using vendor.js in index.html, there is no need of these call
    if (!window['secclient-js-coam']) {
        _x2.loadExternalLibraries( function() { _x2.init(); _x2.begin(); } );
    } else {
        _x2.init();
        _x2.begin();
        if( _x2._splunk === undefined )
        {
            _x2._isSplunkLogging = ['prod', 'staging'].includes(environment.ENV);
            _x2._metricsSocket   = new MetricsSocket();
            _x2._splunk          = new Splunk();
        }
    }// if vendor.js is not loaded from cache server, then application will not load forever
}

window.onLoad = onLoad;

/**
 * Application singleton
 * @class
 */
window.X2 = (function()
{
    "use strict";

    X2.LocalyticsDimension = Object.freeze
    ({
        LOGGED_IN     :  0,
        CONNECTION    :  2,
        UNIVERSITY    :  7,
        X1_USER_TYPE  :  8,
        ACCOUNT_STATUS: 13,
        DEVICE_MODEL  : 15,
        APP_VERSION   : 16
    });

    X2.LocalyticsAccountState = Object.freeze
    ({
        "active"           : "Active",
        "preactive"        : "Pre-active",
        "preactive-timeout": "Limited"
    });

    X2.LocalyticsInHome = Object.freeze
    ({
        "in-home"    : "In Home",
        "out-of-home": "Out Of Home"
    });

    X2.LocalyticsUserType = Object.freeze
    ({
        "churned"   : "Churn",
        "default"   : "Default",
        "smb"       : "SMB",
        "stream"    : "Stream",
        "university": "University"
    });

    X2.prototype = new Widget();

    function X2(){}

    X2.prototype.authorize = function()
    {
        var self               = this;
        var onHasSession       = function() { self.sessionCreated(); };
        var onNeedsCredentials = function( params ) { self.sessionNeedsCredentials( onHasSession, params ); };

        if( this._data === undefined )
            switch( this._config._mode )
            {
                case Config.MODE_UHD:
                    this._data = new ThePlatformApi( this._config._thePlatformRoot );
                    break;

                default:
                    this._data = new XtvApi( this._config._xtvApiRoot );
                    break;
            }

        switch( self._config._authMode )
        {
            case Config.AUTH_CIMA:
                self._authService = new Cima( onHasSession, onNeedsCredentials );
                break;

            case Config.AUTH_CISCO_SAML:
                self._authService = new CiscoSaml(  onHasSession, onNeedsCredentials );
                break;

            case Config.AUTH_NONE:
                setTimeout( onHasSession, 1 );
                break;

            case Config.AUTH_OAUTH:
                self._authService = new Oauth( onHasSession, onNeedsCredentials );
                break;

            case Config.AUTH_XTV:
                self._authService = new XtvAuth( onHasSession, onNeedsCredentials );
                break;

            default:
                console.error( "ERROR -> unknown auth mode = " + self._config._authMode );
                break;
        }

    };

    X2.prototype.begin = function()
    {
        var self = this, onHostInit, onRenderReady, onRenderError;

        onRenderReady = function()
        {
            var shadowFile = [ "", "", "cellShadow_40_40_0_0.png", "cellShadow_61_61_0_0.png" ][_x2._config._layout];

            self._screenRoot  = new StackScreen().init( { name:"ScreenRoot" }  );
            self._overlayRoot = new StackScreen().init( { name:"OverlayRoot", hasBg:true } );
            self._hi          = new SelectionWidget().init( { url:_x2._config._imageRoot + "selection_0_0_5_5.png", w:50, h:50 } );
            self._shadow      = new NineSliceWidget().init( { url:_x2._config._imageRoot + shadowFile, w:50, h:50, pma:false } );

            self._hi.addWidget( self._shadow );
            self._shadow.setPosition( { x:0 , y:0 } );

            self._hi.setA( 0 );
            self._shadow.setA( 0 );

            self.addWidget( self._screenRoot  );
            self.addWidget( self._overlayRoot );
            self.addWidget( self._hi          );
            window.renderStartTime = new Date().getTime();
            console.log("Content start loaded in ", (window.renderStartTime - window.contentLoadTime)/1000 , " secs");

            var onGotFocus = function()
            {
                var top = self._screenRoot.getTop();

                _x2._timeDatum         = Date.now() - _x2._lastStep;
                _x2._minuteTimerDatum -= 60000;

                if( top.refreshCheck )
                    top.refreshCheck();
            };

            window.addEventListener( "focus" , onGotFocus );  // update the time datum after app has been in backround

            self._div = document.body;
            self.patchWidget();

            if( self._screenRoot._div )
                self._screenRoot._div.style.overflow = "hidden";
            
            self._nextFrameFunction = self.getNextFrameFunction();
            self._nextFrameFunction.call( window, self.nextFrame );

            onHostInit = function()
            {
                var onSuccess, onError;

                onSuccess = function( data )
                {
                    var onConfig = function()
                    {
                        if( _x2._config._xtvStage === true ) {
                            _x2._config._xtvApiRoot = "https://xtvapi-staging.cloudtv.comcast.net/";
                            _x2._config._xcalEndPoints = {
                                authenticationActivationUrl: 'https://xacs-activation-stage.cs.xcal.tv',
                                authenticationRenewalUrl: 'https://xacs-renewal-stage.cs.xcal.tv',
                                deviceProvisionUrl: 'https://xacsa-stage.ccp.xcal.tv',
                                licenseAcquisitionUrl: 'https://mds-stage.ccp.xcal.tv'
                            };
                            _x2._config._licenseServer = _x2._config._xcalEndPoints.licenseAcquisitionUrl;
                            _x2._config._provHost = _x2._config._xcalEndPoints.deviceProvisionUrl;
                        }//Change the license server and device provision url to staging

                        if (_x2._config._stageEnv == 'stage2') {
                            _x2._config._xtvApiRoot = "https://xtvapi-aws-us-east-1-staging-2-active.r53.aae.comcast.net/";
                        }
                        self.authorize();
                    };

                    _x2._st = data;
                    self._config.load( onConfig );
                };

                onError = function( error )
                {
                    if( error.data )
                    {
                        console.log( "ERROR -> unable to load selected language, defaulting to English: " + error.error.status );
                        onSuccess( error.data );
                    }
                    else
                        console.log( "ERROR -> unable to load any language: " + error.error.status );
                };

//                self.setScreen( new LoadingScreen().init() );
                new Strings().load( Strings.Language.ENGLISH ).then( onSuccess ).catch( onError );
            };

            self.setScreen( new LoadingScreen().init() );
            self._config._host.init( onHostInit );
        };

        onRenderError = function( e )
        {
            if( e ) // WebGL.init() returns undefined if DOM was specified
                console.error( e );

            if( Widget.glCanvas )
                Widget.glCanvas.parentNode.removeChild( Widget.glCanvas );

            Widget.gl = undefined;

            self._config._render = Config.RENDER_DOM;
            onRenderReady();
        };

        this._moneyTrace = new MoneyTrace();
        this._network    = new Network();

        // Add global Features object
        this._features = new Features();

        // Localytics
        var key       = this._config._localyticsKey;

        window.LocalyticsGlobal = 'll';
        window.ll = function()
        {
            //(window.ll.q = window.ll.q || []).push(arguments);
            return false;
        };// remove localytics, since it was not in used
        window.ll.t = Date.now();

        /*var script     = document.createElement('script');
        script.type    = 'text/javascript';
        script.src     = 'https://web.localytics.com/v3/localytics.min.js';
        script.onerror = function()  // Localytics does not check if the load fails which causes ll() to consume unbounded memory
        {
            if( environment.ENV !== 'prod' )
                console.log( 'INFO -> Failed to load Localytics' );
            window.ll = function() {};
            window.ll.q = []; // NOTE: .t is not used
        };

        var nodes = document.getElementsByTagName('script')[0];
        nodes.parentNode.insertBefore( script, nodes );
        window.ll( 'init', key, {} );*/

        this._config.debugAddClass( Config.CLASS_LOCALYTICS, 0 );

        /*
        NOTE:
            The unminified code above is the manually cleaned up version of
            the original Localytics minified code below from
                https://docs.localytics.com/dev/web.html#integrate-web

        var loadLocalytics = function( l, y, t, i, c, s )
        {
            l['LocalyticsGlobal'] = i;
            l[i] = function() {
                (l[i].q = l[i].q || []).push(arguments)
            };
            l[i].t = +new Date;
            (s = y.createElement(t)).type = 'text/javascript';
            s.src = 'http://web.localytics.com/v3/localytics.min.js';
            (c = y.getElementsByTagName(t)[0]).parentNode.insertBefore(s, c);

            ll( 'init', key, {} );
        };

        loadLocalytics( window, document, 'script', 'll' );
        */

        _x2.localyticsLogout();

        _x2._isSplunkLogging = ['prod', 'staging'].includes(environment.ENV);

        // hacky way to preload the fonts

        var preloads =
        [
            new StringWidget().init( { text:"?", style:new Style( { font:"bold"   , color:"#e8e8e8", fontSize:_x2.scaleValInt(24) } ) } ),
            new StringWidget().init( { text:"?", style:new Style( { font:"light"  , color:"#e8e8e8", fontSize:_x2.scaleValInt(24) } ) } ),
            new StringWidget().init( { text:"?", style:new Style( { font:"medium" , color:"#e8e8e8", fontSize:_x2.scaleValInt(24) } ) } ),
            new StringWidget().init( { text:"?", style:new Style( { font:"regular", color:"#e8e8e8", fontSize:_x2.scaleValInt(24) } ) } ),
            new StringWidget().init( { text:"?", style:new Style( { font:"thin"   , color:"#e8e8e8", fontSize:_x2.scaleValInt(24) } ) } )
        ];

        for( var i = 0; i < preloads.length; i++ )
            this.addWidget( preloads[i] );

        var removeTempString = function()
        {
            for( var i = 0; i < preloads.length; i++ )
                self.removeWidget( preloads[i] );
        };

        setTimeout( removeTempString, 1 );

        // set up the UI layers

        this._videoRoot                       = document.createElement( 'div' );
        this._videoRoot.id                    = "VideoRoot";
        this._videoRoot.style.position        = "absolute";
        this._videoRoot.style.left            = "0px";
        this._videoRoot.style.top             = "0px";
        this._videoRoot.style.width           = this._config._screenW + "px";
        this._videoRoot.style.height          = this._config._screenH + "px";
        this._videoRoot.style.overflow        = "hidden";
        this._videoRoot.style.backgroundColor = "#000000";
        document.body.appendChild( this._videoRoot );

        Widget.glInit().then( onRenderReady ).catch( onRenderError );

        if( this._config._ja )
        {
            var onClose = function( event )
            {
                console.log( "Joshalytics socket CLOSED" );
                console.log( event );

                switch( event.code )
                {
                    case 1000:
                        console.log( "CLEAN CLOSE" );
                        break;

                    case 1005:
                        self._ja = new Joshalytics( params );
                        break;

                    case 1006:
                        setTimeout( function() { self._ja = new Joshalytics( params ); }, 5000 );
                        break;

                    default:
                        console.error( "Unsupported socket close event." );
                        break;
                }
            };

            var onError = function( obj )
            {
                console.log( obj );
            };

            var onMessage = function( obj )
            {
                var val;

                console.log( obj );

                switch( obj.type )
                {
                    case Joshalytics.Type.KEY_PRESS:
                        val = Host.mapKeyVal( Host.mapKeyStr( obj.data ) );

                        if( val !== undefined )
                        {
                            _x2.routeKey( val, Host.KEY_PRESSED );
                            _x2.routeKey( val, Host.KEY_RELEASED );
                        }
                        break;
                }
            };

            var onOpen = function( obj )
            {
                console.log( obj );
            };

            var params = {};

            params.server    = "ws://" + this._config._ja;
            params.onClose   = onClose;
            params.onError   = onError;
            params.onMessage = onMessage;
            params.onOpen    = onOpen;

            this._ja = new Joshalytics( params );
        }
    };

    X2.prototype.createTimeRange = function( startDate, stopDate )
    {
        var retval, raw, hours, mins;

        hours  = startDate.getHours() % 12;
        mins   = startDate.getMinutes();

        retval = (hours === 0 ? 12 : hours) + ":" + (mins < 10 ? "0" + mins : mins);

        raw    = stopDate.getHours();
        hours  = raw % 12;
        mins   = stopDate.getMinutes();

        if( raw === 0 && mins === 0 )
            retval += "p";
        if( raw === 12 && mins === 0 )
            retval += "a";

        retval += " - " + (hours === 0 ? 12 : hours) + ":" + (mins < 10 ? "0" + mins : mins) + (raw > 11 ? "p" : "a");

        return retval;
    };

    X2.prototype.createTimeSpeechStr = function( str )
    {
        var retval = str;

        retval = retval.replace( ":00", "" );
        retval = retval.replace( ":30", " thirty" );
        retval = retval.replace( "a", " am. " );
        retval = retval.replace( "p", " pm. " );
        retval = retval.replace( " - ", " to " );

        return retval;
    };

    /**
     * Utility
     * @memberof X2
     * @param {Date} date
     * @returns {String}
     */
    X2.prototype.createTimeStr = function( date )
    {
        if( date === undefined )
            date = _x2._config._host.getCurrentDateTime();

        var hour    = date.getHours();
        var mins    = date.getMinutes();
        var dayPart = (hour > 11) ? "p" : "a";

        hour = hour % 12;

        if( hour === 0 )
            hour = 12;

        mins = ((mins < 10) ? "0" : "") + mins;

        return hour + ":" + mins + dayPart;
    };

    /**
     * Create a "Expires in..." string
     * @memberof X2
     * @param {Date} date
     * @returns {String}
     */
    X2.prototype.createExpiresString = function( date )
    {
        var expiresString, now = Date.now();

        if( date > now )
        {
            var expiresInMinutes = Math.floor((date - now) / 60000);
            var expiresInHours   = Math.floor(expiresInMinutes / 60);
            var expiresInDays    = Math.floor(expiresInHours   / 24);
            var expireElements   = [];

            if( expiresInDays > 0 )
                expireElements.push( expiresInDays + ( expiresInDays > 1 ? " days" : " day" ) );

            if( expiresInHours % 24 > 0 )
                expireElements.push( expiresInHours % 24 + ( ( expiresInHours % 24 ) > 1 ? " hrs" : " hr") );

            if( expiresInDays === 0) //only show minutes when < 24 hours.
                expireElements.push( expiresInMinutes % 60 + ( ( expiresInMinutes % 60 ) > 1 ? " mins" : " min") );

            if( expireElements.length > 0 )
                expiresString = "Expires in " + expireElements.join(", ");
        }
        else
            expiresString = "Expired";

        return expiresString
    };

    /**
     * Create a "Expires in..." string for speech
     * @param {Date} date
     * @return {string}
     */
    X2.prototype.createExpiresSpeechString = function( date )
    {
        return this.createExpiresString( date )
            .replace("mins", "minutes")
            .replace("min" , "minute" )
            .replace("hrs" , "hours"  )
            .replace("hr"  , "hour"   );
    };

    /**
     * Create a short date string where using 'today' and 'yesterday' for recent dates.
     * @param date
     * @param {boolean} [on] - show 'on' when date is not 'Today' or 'Yesterday'
     * @returns {String}
     */
    X2.prototype.createDateStr = function( date, on )
    {
        var result, now = new Date();

        if( now.getMonth() === date.getMonth() && now.getYear() === date.getYear() )
        {
            if( now.getDate() === date.getDate() )
                result = "Today ";
            else if( now.getDate() - 1 === date.getDate() )
                result = "Yesterday "
        }

        if( result === undefined )
            result = ( on ? " on " : "" ) + ( date.getMonth() + 1 ) + '/' + date.getDate() + " ";

        return result;
    };

    /**
     * Create a short date/time string where using 'today' and 'yesterday' for recent dates.
     * @param date
     * @returns {String}
     */
    X2.prototype.createDateTimeStr = function( date )
    {
        return this.createDateStr( date ) + this.createTimeStr( date );
    };

    /**
     * Walk the screen root chain looking for the specific screen type
     * @param {Widget} type - screen type to find. i.e. VideoScreen
     * @returns undefined if screen not found else the screen object
     */
    X2.prototype.findScreen = function( type )
    {
        var retval, i, n;

        if( this._screenRoot )
        {
            n = this._screenRoot._children.length;

            for( i = 0; i < n; i++ )
                if( this._screenRoot._children[ i ] instanceof type )
                {
                    retval = this._screenRoot._children[ i ];
                    break;
                }
        }

        return retval;
    };

    X2.prototype.fetchChannelCollection = function()
    {
        var self = this;

        if( this._channelCollection === undefined )
        {
            var resolver = function( resolve, reject )
            {
                var onGotChannels = function( cc )
                {
                    self._channelCollection = cc;
                    resolve();
                };
                self._data.getChannelCollection().then( onGotChannels ).catch( reject );
            };
            return new Promise(resolver);
        }
        else
            return Promise.resolve( this._channelCollection );
    };

    X2.prototype.getBrowseFilterString = function()
    {
        var retval, vals = _x2._settings.getValue( Settings.Key.FILTERS );

        if( vals )
            for( var key in vals )
                if( vals[key] === true )
                {
                    key    = (key    === "cc"     ) ? "closedcaption" : key;
                    retval = (retval === undefined) ? key             : retval + "," + key;
                }

        return retval;
    };

    X2.prototype.getNextFrameFunction = function()
    {
        return  window.requestAnimationFrame       ||
                window.mozRequestAnimationFrame    ||
                window.webkitRequestAnimationFrame ||
                window.msRequestAnimationFrame     ||
                window.oRequestAnimationFrame      ||
                function( callback ) { window.setTimeout( function() { callback( (new Date()).getTime() ); }, 1000/30 ); };
    };

    X2.prototype.getOverlayRootLastFocus = function()
    {
        return this._overlayRoot._children[0]._lastFocus;
    };

    X2.prototype.getScript = function( url, onSuccess, onError )
    {
        var script;

        script         = document.createElement( "script" );
        script.type    = "text/javascript";
        script.onload  = onSuccess;
        script.onerror = onError;
        script.src     = url;
        script.async   = true;
        document.getElementsByTagName('head')[0].appendChild( script );
    };

    X2.prototype.getTopScreen = function()
    {
        return this._screenRoot.getTop();
    };

    X2.prototype.loadExternalLibraries = function( onLoaded )
    {
        var libs =
        [
            "lib/base64_js.js",
            "lib/base64url.js",
            "lib/bn_js.js",
            "lib/elliptic.js",
            "lib/fast_sha256.js",
            "lib/lodash.js",
            "lib/randombytes.js",
            "lib/url_join.js",
            "lib/url.js",
            "lib/money-trace.js",
            "lib/secclient-js-coam.js",
            "lib/PlayerPlatformAPI.js"
        ];

        var index = 0;

        var onError = function( e )
        {
            var msg = "Unable to load Javascript file = " + e.target.src;

            console.error( msg );

            if( _x2._splunk === undefined )
            {
                _x2._isSplunkLogging = ['prod', 'staging'].includes(environment.ENV);
                _x2._metricsSocket   = new MetricsSocket();
                _x2._splunk          = new Splunk();
            }

            if( _x2._splunk !== undefined )
                _x2._splunk.sendGeneralError( msg, "TVAPP-00100" );
        };

        var loadNextLibrary = function()
        {
            var url = libs[index++];

            if( url )
                _x2.getScript( url, loadNextLibrary, onError );
            else
                onLoaded();
        };

        loadNextLibrary();
    };

    X2.prototype.init = function()
    {
        Widget.prototype.init.call( this );
        this._className = "X2";

        var self   = this;
        var index  = document.URL.indexOf( '?' );
        var params = {};
        this.keyEventHistory = [];

        window.onkeydown = function( event ) { self.onKeyDown( event ); };
        window.onkeyup   = function( event ) { self.onKeyUp  ( event ); };
        window.onunload  = function( event ) { self.onUnload ( event ); };

        this._repeat = false;

        // create a new default config

        this._config = new Config( true );
        this._config.debugAddClass( Config.CLASS_GRID, 1 );
        this._config.debugAddClass( Config.CLASS_X2, 0 );
//      this._config.debugAddClass( Config.CLASS_WEBGL, 0 ); // WebGL Widget Inspector
        this._config.log( Config.CLASS_X2, 1 ) ? console.log( document.URL ) : Config.NOP();

        // pull parameters from the app URL

        if( index !== -1 )
        {
            var nameVal, pairs;

            pairs = document.URL.substring( index + 1, document.URL.length ).split( '&' );

            for( var i = 0; i < pairs.length; i++ )
            {
                nameVal = pairs[i].split('=');
                params[nameVal[0]] = nameVal[1];
            }
        }

        this._config.log( Config.CLASS_X2, 5 ) ? console.log( params ) : Config.NOP();

        if( this.parseBoolean( params["enabledCursor"] ) === true ) {
            document.addEventListener('cursorStateChange', self.cursorVisibilityChange, false);
        }
        if( params["size"] )
            this._config.setSize( params["size"] );

        if( params["ja"] )
            this._config._ja = params["ja"];

        if( params["testVid"] )
            this._config._testVideo = params["testVid"];

        this._config._startTime    = parseInt( params["time"] );
        this._config._cvpConf      = this.parseCvpParams( params["gw" ] );
        this._config._mac          = params["mac"];
        this._config._platform     = params["platform"];
        this._config._mode         = params["mode"];
        this._config._password     = params["p"];
        this._config._username     = params["u"];
        this._config._configServer = params["config"];
        this._config._cursorEnabled = this.parseBoolean( params["enabledCursor"] );
        this._config._text         = params["text"] ? params["text"] : 1;
        this._config._skipProv         = this.parseBoolean( params["skipProv"] );
        this._config._skipInHome   = this.parseBoolean( params["skipInHome"] );
        this._config._itv          = this.parseBoolean( params["itv"] );
        this._config._speech       = params["speech"] ? this.parseBoolean( params["speech"] ) : true;
        this._config._ppLog        = this.parseBoolean( params["ppLog"] );
        this._config._altVid       = this.parseBoolean( params["altVid"] );
        this._config._minDraw      = params["minDraw"] ? this.parseBoolean( params["minDraw"] ) : true;
        this._frameTime            = params["fps"] ? 1000 / parseInt( params["fps"] ) : 1;
        this._config._partner      = params["partner"] ? params["partner"] : "Comcast";
        this._config._allowPurch   = params["purchases"] ? this.parseBoolean( params["purchases"] ) : false;
        this._config._previewRoot  = this.parseBoolean( params["previewRoot"] );
        this._config._xtvStage     = this.parseBoolean( params["xtvStage"] );
        this._config._stageEnv     = params["stageEnv"];
        this._config._loadConfigId = params["loadConfigId"] || null;
        this._config._loadWebcrypto     = this.parseBoolean( params["loadWebcrypto"] ); //load ecdh crypto type in LG TV for dev url
        this._config._showResumePoint = this.parseBoolean( params["showResumePoint"] );

        this._config._secClientV2Var = 'secclient-js-coam'; //this contains secClient version 2.0.2

        this._config._render = ( params["webgl"] === undefined )
                             ? Config.RENDER_DOM
                             : ( this.parseBoolean( params["webgl"] ) === true)
                               ? Config.RENDER_WEBGL
                               : Config.RENDER_DOM;
        this._config._smartHubEntityId = params['smartHubEntityId'] ? params['smartHubEntityId'] : null;
        this._config._appendHeaders = params['appendHeaders'] ? decodeURIComponent(params['appendHeaders']) : null; 

        if( location.pathname.indexOf( "x2app" )       !== -1 || this._config._mode === "cloud" )
            this._config.setAppMode( Config.MODE_CLOUD );
        else if( location.pathname.indexOf( "x2rui" )  !== -1 || this._config._mode === "rui" )
            this._config.setAppMode( Config.MODE_RUI, params["partner"] );
        else if( location.pathname.indexOf( "x2test" ) !== -1 || this._config._mode === "test" )
            this._config.setAppMode( Config.MODE_TEST );
        else if( location.pathname.indexOf( "x2uhd" )  !== -1 || this._config._mode === "uhd" )
            this._config.setAppMode( Config.MODE_UHD );
        else
            this._config.setAppMode( Config.MODE_CLOUD, params["partner"] );

        // determine what platform running

        var agent = navigator.userAgent;

        console.log( agent );
        console.log( window.location.href );
        console.log( "Version = " +  AboutOverlay.version );
        console.log( "SecClient Version = " + window[ _x2._config._secClientV2Var ].SecClient.getVersion() );

        // LG    2017   Mozilla/5.0 (Web0S; Linux/SmartTV) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/38.0.2125.122 Safari/537.36 WebAppManager
        // LG    2018   Mozilla/5.0 (Web0S; Linux/SmartTV) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/53.0.2785.34 Safari/537.36 WebAppManager
        // Tizen 2017   Mozilla/5.0 (SMART-TV; LINUX; Tizen 3.0) AppleWebKit/538.1 (KHTML, like Gecko) Version/3.0 TV Safari/538.1
        // Tizen 2018   Mozilla/5.0 (SMART-TV; LINUX; Tizen 4.0) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 TV Safari/537.36

        if( agent.indexOf( "Tizen" ) !== -1 )
            this._config._host = new Tizen();
        else if( agent.indexOf( "Web0S" ) !== -1 )
            this._config._host = new Lg();
        else if( agent.indexOf( "Android" ) !== -1 ) // can't reference global 'android'
            this._config._host = new Android();
        else
            this._config._host = new Host();

        Style.initClassVariables( this._config._layout );

        //For each key input event, browser emit two events keyup(KEY_RELEASED) and keypress(KEY_PRESSED)
        //In web simulator, only one event is get trigger(especially after mouse click) that is KEY_RELEASED
        //So we need to trigger KEY_PRESSED manually before the KEY_RELEASED Event
        this._config.isTizenSimulator = this.parseBoolean( params["tizenSimulator"] );
        this._config.isWebOsSimulator = this.parseBoolean( params["webOsSimulator"] );

        //in tv channels section, program name are listed empty for some of the timezone, so skip those check for testing purpose
        this._config.skipBlockTimeCheck = this.parseBoolean( params["skipBlockTimeCheck"] );

        //this will used  javascript date object instead of tizen.time object for debugging purpose
        this._config.useJSTime     = this.parseBoolean( params["useJSTime"] );

        return this;
    };

    /* Initialize Localytics Custom Dimensions
     */
    X2.prototype.localyticsLogout = function( sendLogout )
    {
        _x2._localyticsDimensions =
        [
            "No"         , // 0: Logged In
            undefined    , // 1: Connection Type
            "Out Of Home", // 2: Connection
            undefined    , // 3: Parental Controls
            undefined    , // 4: Screen Reader
            undefined    , // 5: Switch Accessibility
            undefined    , // 6: NPS Score
            null         , // 7: University -> Partner Id
            null         , // 8: X1 User Type
            undefined    , // 9: NPS Group
            undefined    , //10: OOH Filter Enabled
            undefined    , //11: Language
            undefined    , //12: SSID
            "None"       , //13: Account Status
            undefined    , //14: Analytics Group
            undefined    , //15: Device Model
            undefined      //16: App Version
        ];

        this.localyticsSendCustomDimensions();

        if( window.ll && sendLogout )
            window.ll( "tagEvent", "Sign Out" );
    };

    X2.prototype.localyticsSetCustomDimension = function( key, val )
    {
        _x2._localyticsDimensions[ key ] = val; // DEBUG

        if( window.ll )
            window.ll( 'setCustomDimension', key, val );
    };

    X2.prototype.localyticsSetAppVersionAndDeviceModel = function( ) 
    {
        var makeModel  = _x2._config._host._make ? (_x2._config._host._make + " " + _x2._config._host._product) : _x2._config._host._product;
        _x2.localyticsSetCustomDimension( X2.LocalyticsDimension.DEVICE_MODEL  , makeModel );
        _x2.localyticsSetCustomDimension( X2.LocalyticsDimension.APP_VERSION   , AboutOverlay.version );
    };

    X2.prototype.localyticsSendCustomDimensions = function()
    {
        if( window.ll && _x2._localyticsDimensions )
            for( var key = 0; key < _x2._localyticsDimensions.length; key++ )
                if( _x2._localyticsDimensions[ key ] !== undefined )
                    window.ll( 'setCustomDimension', key, _x2._localyticsDimensions[ key ] );
    };

    /**
     * Localytics: Send `Favorite Entity` or `Favorite Entity Viewed`
     * @param {DataObject} entity - Entity, or SportsTeam
     * @param {String}     action - "Add" or "Remove" to send "Favorite Entity"; or "Viewed" to send "Favorite Entity Viewed"
     */
    X2.prototype.localyticsSendFavoriteEntityOrViewed = function( entity, action )
    {
        var metrics =
        {
            "Type"       : "Unknown",
            "Entity Name": entity && entity.getTitle()
        };

        var type = entity instanceof SportsTeam ? XtvApi.EntityType.OTHER : entity && entity.getType && entity.getType();

        switch( type )
        {
            case XtvApi.EntityType.SERIES : metrics.Type = "TV Show"    ; break;
            case XtvApi.EntityType.MOVIE  : metrics.Type = "Movie"      ; break;
            case XtvApi.EntityType.EPISODE: metrics      = null         ; break; // Don't send
            case XtvApi.EntityType.OTHER  : metrics.Type = "Sports Team"; break; // XtvApi.EntityType missing dedicated SPORTS
            default                       : metrics      = null         ;
                console.error( "Unhandled Favorite Entity type: " + type );
                break;
        }

        if( metrics )
        {
            if( action !== "Viewed" ) // Add/Remove
            {
                metrics["Action"] = action;

                _x2._config.log( Config.CLASS_LOCALYTICS, 3 ) ? console.log( "Localytics: " + action + " Favorites: %o", metrics ) : Config.NOP();
                window.ll( "tagEvent", "Favorite Entity", metrics );
            }
            else if( (_x2._screenRoot._children.length > 0) && (_x2._screenRoot._children[ 1 ] && _x2._screenRoot._children[ 1 ]._termStr === "Favorites") ) // Only allowed for: Saved / Favorites
            {
                _x2._config.log( Config.CLASS_LOCALYTICS, 3 ) ? console.log( "Localytics: Favorite Entity Viewed: %o", metrics ) : Config.NOP();
                window.ll( "tagEvent", "Favorite Entity Viewed", metrics );
console.log( "Favorite Entity Viewed: " + metrics["Entity Name"] + ", Type: " + metrics.Type );
            }
        }
    };

    X2.prototype.localyticsSendSplashPageAndProvisioning = function()
    {
        var type    = _x2._config._host.getType();
        var metrics =
        {
            version                : AboutOverlay.version,
            platform               : _x2._config._host.getPlatformString(),
            oemName                : "unknown",
            oemModel               : _x2._config._host._product ? _x2._config._host._product : "development",
            browser                : navigator ? navigator.userAgent : "unknown",
            deviceName             : "unknown",
            deviceModel            : "unknown",
//          deviceId               : "0", // REMOVED: PII
//          xboAccountId           : "0", // REMOVED: PII
            firstAuthentication    : _x2._metricsFirstAuthentication ? "yes" : "no",
            entitlements           : "",
            isCDVREntitled         : "no",
            isCloudServiceAvailable: "no",
            isLinearEntitled       : "no",
            isVODEntitled          : "no",
            analyticsId            : "0"
        };

        var tokenXsct = JSON.parse( Host.getLocalStorage( "XsctToken" ) );
        if( tokenXsct )
        {
            var tokenSummary = tokenXsct.tokenSummary;

            metrics.isCDVREntitled          = tokenSummary.isCDVREntitled          ? "yes" : "no";
            metrics.isCloudServiceAvailable = tokenSummary.isCloudServiceAvailable ? "yes" : "no";
            metrics.isLinearEntitled        = tokenSummary.isLinearEntitled        ? "yes" : "no";
            metrics.isVODEntitled           = tokenSummary.isVODEntitled           ? "yes" : "no";
//          metrics.xboAccountId            = tokenSummary.xboAccountId; // REMOVED: PII
            metrics.entitlements            = tokenSummary.entitlements.join(",");
//          metrics.deviceId                = tokenSummary.deviceId; // REMOVED: PII
            metrics.analyticsId             = tokenSummary.analyticsId; // non-PII replacement for deviceId and xboAccountId. See wiki: Analytics+Tracking+ID

            if( _x2._metricsDeviceInfo )
            {
                metrics.deviceName  = _x2._metricsDeviceInfo.deviceName;
                metrics.deviceModel = _x2._metricsDeviceInfo.deviceModel;
            }
        }

        // Convert oemName into human readable string
        // Localytics 2.1.1
        // Localytics 2.2.1
        switch( type )
        {
            case Host.Type.ANDROID: metrics.oemName = "Android"; break;
            case Host.Type.LG     : metrics.oemName = "LG"     ; break;
            case Host.Type.TIZEN  : metrics.oemName = "Samsung"; break;
            case Host.Type.PC     : metrics.oemName = "Desktop"; break;
        }

        window.ll( 'tagEvent', "Splash page transition", metrics ); // Localytics 2.1.1
        _x2._config.log( Config.CLASS_LOCALYTICS, 2 ) ? console.log( "Localytics: Splash Page event: %o", metrics ) : Config.NOP();

        // When we provisioned we couldn't send telemetry since it is not created until after we acquired the XsctToken
        if( _x2._metricsFirstAuthentication )
            _x2._telemetry.sendProvisioning( _x2._metricsTimerAuthentication, "NA" );
        else
            _x2._telemetry.sendProvisioning( 0, "NA" );
    };

    X2.prototype.nextFrame = function( step )
    {
        var date, gl;

        if( _x2._lastStep === undefined )
        {
            date                  = new Date();
            _x2._lastStep         = step - _x2._frameTime - 1; //34;
            _x2._timeDatum        = date.getTime();
            _x2._minuteTimerDatum = step - date.getSeconds() * 1000 - date.getMilliseconds() + 3000;
        }

        if( (step - _x2._lastStep) >= _x2._frameTime )
        {
            if( (step - _x2._minuteTimerDatum) > 60000 )
            {
                _x2._config.log( Config.CLASS_X2, 7 ) ? console.log( "TICK TICK TICK TICK - " + (step - _x2._minuteTimerDatum) ) : Config.NOP();
                _x2.callbackSignalChange();

                do
                {
                    _x2._minuteTimerDatum += 60000;
                }
                while( (step - _x2._minuteTimerDatum) > 60000 );
            }

            if( _x2._config._render === Config.RENDER_WEBGL )
            {
                gl = Widget.gl;

    //          if( !X2.SingleStep ) // DEBUG Time Step
                    gl.clear( gl.COLOR_BUFFER_BIT | gl.STENCIL_BUFFER_BIT );
    /*
                if( _x2._config.log( Config.CLASS_WEBGL, 1 ) ) // WebGL Widget Inspector
                    Widget.glDebugIdx = 0;
    // */
            }

    //      if( !X2.SingleStep ) // DEBUG Time Step
            {
                _x2._lastStep = step;
                _x2._time     = _x2._timeDatum + step;
                _x2.update( step );
                _x2._nextFrameFunction.call( window, _x2.nextFrame );
            }

            if( _x2._config._render === Config.RENDER_WEBGL )
            {
    //          if( !X2.SingleStep ) // DEBUG Time Step
                {
                    _x2.glRender( 1 );
                    gl.flush();
                }
    /*
                if( _x2._config.log( Config.CLASS_WEBGL, 1 ) ) // WebGL Widget Inspector
                {
                    if( Widget.glWidgetCapture )
                        Widget.glWidgetCapture = undefined;

                    if( Widget.glDebugOutline )
                        for( var i = 0; i < 4; i++ )
                            Widget.glDebugOutline[i].update( 0, 1 );
                }
    // */
            }
        }
        else
            _x2._nextFrameFunction.call( window, _x2.nextFrame );
    };

    X2.prototype.onKeyDown = function( event )
    {
        var retval = false, val, type;
        if( this._config.isTizenSimulator || this._config.isWebOsSimulator ) {
            window.setTimeout( function(){
                this.pushIntoKeyEventHistory( event );
            }, 0);
        }
        this._config.log( Config.CLASS_X2, 8 ) ? console.log( "Key DOWN " + event.keyCode + ", " + event.key +  ", shift = " + event.shiftKey + ", control = " + event.ctrlKey + ", alt = " + event.altKey + ", meta = " + event.metaKey ) : Config.NOP();
        if( event.ctrlKey === false && event.altKey === false && event.metaKey === false )
        {
            val  = this._config._host.mapKey( event );
            type = Host.KEY_PRESSED;

            if( this._lastKey === val )
                type = Host.KEY_REPEAT;

            // handle global key press, else pass to widget with focus, bubble back up

            if( val > 0 && this._repeat === false )
            {
                if( this.routeKey( val, type ) === true )
                {
                    event.preventDefault();
                    event.stopPropagation();
                    retval = true;
                }
            }
            else
            {
                event.preventDefault();
                event.stopPropagation();
                retval = true;
            }

            if( type === Host.KEY_REPEAT )
                this._repeat = true;

            this._lastKey = val;
        }

        return retval;
    };

    X2.prototype.onKeyUp = function( event )
    {
        this._config.log( Config.CLASS_X2, 9 ) ? console.log( "Key UP " + event.keyCode +  ", shift = " + event.shiftKey + ", control = " + event.ctrlKey + ", alt = " + event.altKey + ", meta = " + event.metaKey ) : Config.NOP();
        if( this._config.isTizenSimulator || this._config.isWebOsSimulator ) {
            window.setTimeout( function() {
                this.pushIntoKeyEventHistory( event );
            }.bind(this), 0);
        }
        if( event.ctrlKey === false && event.altKey === false && event.metaKey === false )
        {
            this._repeat  = false;
            this._lastKey = undefined;
            var type = (window.onkeydown && window.onkeydown.toString().indexOf('onKeyDown') > -1 ) ? Host.KEY_RELEASED : Host.KEY_PRESSED; //if samsung smarthub, onkeydown was null so we need change the event type to KEY_PRESSED
            this.routeKey( this._config._host.mapKey( event ), type );
        }
/*
        if( this._config.log( Config.CLASS_X2, 2 ) ) // DEBUG Time Step
        {
            // ms = 1000/Hz
            if( event.keyCode === Host.KEY_TAB ) // TAB = Advance one frame
            {
                var gl = Widget.gl;
                if( gl )
                    gl.clear( gl.COLOR_BUFFER_BIT | gl.STENCIL_BUFFER_BIT );

                _x2._lastStep += (X2.msTimeStep || 25); // Default 25 ms = 1000ms/s / 25ms = 40 Hz
                _x2.update( _x2._lastStep, 1 );

                if( gl )
                    gl.flush();
            }

            if( event.keyCode === 190 ) // '.' = Toggle Paused/Run frames
            {
                if( !X2.SingleStepDiv )
                {
                    var div0 = document.createElement( 'div' );
                    var div1 = document.createElement( 'div' );

                    div0.id = "DebugPauseContainer";
                    div1.id = "DebugPauseInnerText";

                    // style="display:flex; align-items:center; justify-content:center;"
                    div0.style.alignItems     = "center"; // Vertical
                    div0.style.display        = "flex";
                    div0.style.height         = _x2._config._screenH + 'px';
                    div0.style.justifyContent = "center"; // Horizontal
                    div0.style.left           = "0px";
                    div0.style.position       = "absolute";
                    div0.style.top            = "0px";
                    div0.style.width          = _x2._config._screenW + 'px';

                    div1.innerHTML        = "PAUSED";
                    div1.style.color      = "#FF0000";
                    div1.style.fontFamily = "sans-serif";
                    div1.style.fontSize   = "192px";
                    div1.style.margin     = "0";
                    div1.style.opacity    = "0.25";
                    div1.style.padding    = "0";
                    div1.style.transform  = "rotate(-33deg)";
                    div1.style.zIndex     = "1";

                    div0.appendChild( div1 );
                    document.body.appendChild( div0 );

                    X2.SingleStepDiv = div0;
                }

                X2.SingleStep                  = 1 - (X2.SingleStep | 0);
                X2.SingleStepDiv.style.opacity = X2.SingleStep;

                if( !X2.SingleStep ) // Resume main loop
                    _x2._nextFrameFunction.call( window, _x2.nextFrame );
            }
        }

        if( this._config.log( Config.CLASS_WEBGL, 1 ) ) // WebGL Widget Inspector
        {
            if( event.keyCode === Host.KEY_BRACKET_LEFT )
            {
                Widget.glDebugInspect--;
                if( Widget.glDebugInspect < 0 )
                    Widget.glDebugInspect = 0;
                Widget.glDebug();
            }
            else if( event.keyCode === Host.KEY_BRACKET_RIGHT )
            {
                if( Widget.glWidgetsRendered.length > 0 )
                {
                    Widget.glDebugInspect++;
                    if( Widget.glDebugInspect > Widget.glWidgetsRendered.length-1 )
                        Widget.glDebugInspect = Widget.glWidgetsRendered.length-1;
                    Widget.glDebug();
                }
            }
            else if( event.key === "Alt" )
            {
                Widget.glWidgetCapture = true;
                Widget.glDebugInspect  = 0;
                if( !Widget.glDebugOutline )
                {
                    Widget.glDebugOutline =
                    [
                        new RectWidget().init( { w:1, h:1, color:"#FF0000", a:0.8 } ),
                        new RectWidget().init( { w:1, h:1, color:"#00FF00", a:0.8 } ),
                        new RectWidget().init( { w:1, h:1, color:"#0000FF", a:0.8 } ),
                        new RectWidget().init( { w:1, h:1, color:"#FFFFFF", a:0.8 } ),
                    ];
                    for( var i = 0; i < 4; i++ )
                        Widget.glDebugOutline[i].resourcesLoad();
                }
                Widget.glWidgetsRendered = [];
                Widget.glDebug = function()
                {
                    console.log( "Widget: [%d/%d]: %o", Widget.glDebugInspect, Widget.glWidgetsRendered.length-1, Widget.glWidgetsRendered[ Widget.glDebugInspect ] );
                };
            }
        }
// */
    };

    X2.prototype.onUnload = function()
    {
    };

    /**
     * Utility
     * <p>
     * Gets boolean value of string.
     * <p>
     * NOTE: Returns `undefined` if not a valid boolean.
     * @memberof X2
     * @param {String} str
     * <table class="params">
     * <thead><tr><th>Text</th><th>Returned value</th></tr></thead>
     * <tr><td>"true"<br>"yes"<br>"1"</td><td>true</td></tr>
     * <tr><td>"false"<br>"no"<br>"0"</td><td>false</td></tr>
     * </table>
     * @returns {True|False}
     */
    X2.prototype.parseBoolean = function( str )
    {
        var retval;
        if( str != undefined )
        {
            switch( str.toLowerCase() )
            {
                case "true":
                case "yes":
                case "1":
                    retval = true;
                    break;

                case "false":
                case "no":
                case "0":
                default:
                    retval = false;
                    break;
            }
        } else {
            retval = false;
        }

        return retval;
    };

    X2.prototype.parseCvpParams = function( str )
    {
        var retval;

        if( str )
            retval = JSON.parse( decodeURIComponent( str ) );

        return retval;
    };

    X2.prototype.popOverlay = function( overlay, onPopped )
    {
        return this._overlayRoot.pop( overlay, onPopped );
    };

    X2.prototype.popScreen = function( screen, onPopped )
    {
        return this._screenRoot.pop( screen, onPopped );
    };

    X2.prototype.provision = function()
    {
        var retval, executor, secClientConfig, partnerId, self = this;
        var token = decodeURIComponent( "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" );

        executor = function( resolve, reject )
        {
            var onLoad, onLoadError, onXact, onXactError;

            onXact = function( result )
            {
                var obj = {}, onProvision, onProvisionError, saml;

                console.log( result );

                if( result && (result.status === undefined || result.message === undefined ))
                {
                    _x2._config._host.setLocalStorage( "XactToken", JSON.stringify( result ) );

                    onProvision = function( data )
                    {
                        console.log( data );
                        _x2._data.createDrmSession( result.deviceToken, partnerId ).then( resolve, reject );
                    };

                    onProvisionError = function( e )
                    {
                        var apiError;
                        console.error( e );
                        _x2._splunk.sendProvisionError( e.status, _x2._secClientMoneyTrace );

                        if( e instanceof ApiError )
                             apiError = e;
                         else
                             apiError = new ApiError().init( { flash:e } );

                        reject( apiError );
                    };

                    saml = JSON.parse( Host.getLocalStorage( "XtvAuthToken" ) );
                    console.log( saml );

                    partnerId = saml.partnerId;

                    if( partnerId === "comcast" )
                    {
                        console.log( "Provision Comcast" );
                        obj.serviceHostUrl             = self._config._provHost;
                        obj.deviceAuthenticationResult = result;
                        obj.accountToken               = saml.samlResponse;
                        obj.requestMetadata            = { "X-MoneyTrace": _x2._moneyTrace.createTraceMessage() };

                        console.log( obj );

                        _x2._config._secClientV2.provisionDevice( obj ).then( onProvision, onProvisionError );
                    }
                    else
                    {
                        console.log( "Provision Partner" );

                        _x2._config._xocPartner = partnerId;
                        _x2._data.provisionPartnerDevice( result.deviceToken, encodeURIComponent( saml.samlResponse ), partnerId ).then( onProvision, onProvisionError );
                    }
                }
                else
                {
                    console.error( result? result.status + " " + result.message : "Secclient not loaded.");

                    // TODO display error and exit application
                }
            };

            onXactError = function( e )
            {
                console.log(e);
                _x2._splunk.sendProvisionError( e.status, _x2._secClientMoneyTrace );
                var apiError = new ApiError().init( { flash: e } ); //TODO: SecClient errors should be distinguished from PP errors. Example error {status:403}
                _x2.pushOverlay( new ErrorOverlay().init( { error:apiError, context:ErrorOverlay.Context.COMMON } ) )
            };

            onLoad = function()
            {
                console.log( "Sec Client LOADED" );

                _x2._secClientMoneyTrace = { "X-MoneyTrace": _x2._moneyTrace.createTraceMessage() };

                console.log( _x2._secClientMoneyTrace );
                var params = { 
                    serviceHostUrl : self._config._authHost,
                    requestMetadata: _x2._secClientMoneyTrace 
                };
                var xactToken = Host.getLocalStorage( "XactToken" ) && JSON.parse( Host.getLocalStorage( "XactToken" ) );
                if( xactToken ) {
                    params.deviceAuthenticationResult = xactToken;
                }
                return _x2._config._secClientV2.authenticateDevice( params );
            };

            onLoadError = function( e )
            {
                console.error( e );
                _x2._splunk.sendProvisionError( e.status, secClientConfig);
            };
            window.sessionStartCreatingAt = new Date().getTime();
            console.log("Creating the DRM Session at ", new Date());
            _x2._config._secClientV2 = new window[ _x2._config._secClientV2Var ].SecClient();
            _x2._config._secClientV2.load( secClientConfig ).then( onLoad, onLoadError ).then( onXact, onXactError );
        };
        if( this._config._skipProv === true )
        {
            console.log( "Provision default with canned XACT token" );
            window.sessionStartCreatingAt = new Date().getTime();
            console.log("Creating the DRM Session at ", new Date());
            var tokenFromLocalStorage        = Host.getLocalStorage( "tv-tokens-u" ); //If we update the token from xfintity-stream, then it will take that token instead of from code.
            tokenFromLocalStorage        = (tokenFromLocalStorage && JSON.parse( tokenFromLocalStorage )) || {};    
            token = ( tokenFromLocalStorage.xact )? tokenFromLocalStorage.xact : token;
            retval = _x2._data.createDrmSession( token, "comcast" );
        }
        else
        {
            var cryptoType = _x2._config._host.getCryptoType();
            var deviceType = _x2._config._host.getSecClientDeviceType();

            secClientConfig =
            {
                crypto:
                {
                    type: cryptoType
                },
                timeout: 15000
            };

            if( deviceType )
                secClientConfig.deviceType = deviceType;

            retval = new Promise( executor );
        }

        return retval;
    };

    X2.prototype.pushOverlay = function( overlay )
    {
        this._overlayRoot.push( overlay );
    };

    X2.prototype.pushScreen = function( screen )
    {
        this._screenRoot.push( screen, (screen instanceof VideoScreen) ? 1 : undefined );
    };

    X2.prototype.requestFocus = function( widget, newScreen )
    {
        var retval;

        if( widget && widget._selectable === true )
        {
            this._lastWidgetFocus = this._focus;            
            if( this._focus )
                this._focus.lostFocus( widget );

            this._focus = widget;
            retval = this._focus.gotFocus( this._lastWidgetFocus, newScreen );
        }

        return retval;
    };

    X2.prototype.popTopOfstack = function()
    {
        var self = this, onConfirm, overlay;

        if( this.popOverlay() === false )
            if( this.popScreen() === false )
            {
                var top = this._screenRoot.getTop();

                if( top instanceof WelcomeScreen === false && top instanceof MainMenuScreen === false && top instanceof NotEntitledScreen === false && top instanceof DeviceNameScreen === false && top instanceof TermsScreen === false && top instanceof ChurnedMainMenuScreen === false )
                {
                    this.setScreen( new MainMenuScreen().init() );
                }
                else if( this._config._host.exitApp )
                {
                    onConfirm = function()
                    {
                        if( _x2.logoutOnExit === true )
                        {
                            _x2._authService.logout();
                            _x2.localyticsLogout( true );
                        }

                        _x2.popOverlay( overlay );
                        self._config._host.exitApp( false );
                    };

                    overlay = new ExitAppOverlay().init( { onEnter:onConfirm } );
                    _x2.pushOverlay( overlay );
                }
            }
    };

    X2.prototype.refreshResumePoints = function( cancelOnDemand )
    {
        cancelOnDemand = cancelOnDemand || false;
        var success = function( data )
        {
            _x2._resume = data;
        };

        var fail = function( error )
        {
            console.log( "Resume api fails", error.toString() );
        };

        return _x2._data.getResumePoints(null, cancelOnDemand ).then( success ).catch( fail );
    };
    /**
     * set resume point for media in cache
     */
    X2.prototype.setResumePointInCache = function( mediaId, lastResumePoint)
    {
        var i;

        if( _x2._resume && _x2._resume.length )
        {
            for( i = 0; i < _x2._resume.length; i++ )
            {
                if( mediaId === _x2._resume[i].getMediaId() )
                {
                    _x2._resume[i].setPosition( lastResumePoint );
                    break;
                }
            }
        }
    };

    X2.prototype.refreshFavorites = function()
    {
        var success = function( obj )
        {
            _x2._favorites = obj
        };

        var fail = function( error )
        {
            console.log( error.toString() );
        };

        return _x2._data.getFavorites().then( success ).catch( fail );
    };

    X2.prototype.routeKey = function( val, type )
    {
        var self = this, onConfirm, overlay;

//        if( ! this._keysBlocked )
        {
            var retval = true;  // stop propagation of the key press event

            switch( val )
            {
                case Host.KEY_QUIT_NOW:
                    retval = false;
                    break;

                default:
                    if( this._focus )
                    {
                        if( this._focus.processEvent )
                        {
                            // bubble key press from the widget that has focus through its parents until handled

                            var handled = false;
                            var widget  = this._focus;

                            while( widget != undefined && handled === false )
                            {
                                handled = widget.processEvent( val, type );
                                widget  = widget._parent;
                            }

                            // if key press was not consumed, then execute default handler

                            if( handled === false )
                            {
                                this._config.log( Config.CLASS_X2, 7 ) ? console.log( "Key press not handled by widget in focus, val = " + val ) : Config.NOP();

                                switch( val )
                                {
                                    case Host.KEY_LAST:
                                        if( type === Host.KEY_PRESSED )
                                            this.popTopOfstack();
                                        break;

                                    case Host.KEY_QUIT:
                                        if( type === Host.KEY_PRESSED )
                                            if( this._config._host.exitApp )
                                            {
                                                onConfirm = function()
                                                {
                                                    if( _x2.logoutOnExit === true )
                                                    {
                                                        _x2._authService.logout();
                                                        _x2.localyticsLogout( true );
                                                    }

                                                    _x2.popOverlay( overlay );
                                                    self._config._host.exitApp( true );
                                                };

                                                overlay = new ExitAppOverlay().init( { onEnter:onConfirm } );
                                                _x2.pushOverlay( overlay );
                                            }
                                        break;
                                }
                            }
                        }
                        else
                            console.log( "ERROR -> widget currently in focus does not have a processEvent method" );
                    }
                    else
                        console.log( "ERROR -> no widget currently in focus" );
                    break;
            }

            return retval;
        }
    };

    /**
     * Utility
     * <p>
     * Returns the height specified at 1080 resolution scaled down for other resolutions
     * @memberof X2
     * @param {Number} val
     * @returns {Number}
     */
    X2.prototype.scaleVal = function( val )
    {
        return ( val !== undefined ) ? val * this._config._screenH / 1080 : undefined;
    };

    /**
     * Utility
     * <p>
     * Returns the height specified at 1080 resolution scaled down for other resolutions
     * @memberof X2
     * @param {Number} val
     * @returns {Number}
     */
    X2.prototype.scaleValInt = function( val )
    {
        return ( val !== undefined ) ? parseInt( val * this._config._screenH / 1080 ) : undefined;
    };

    X2.prototype.sessionCreated = function()
    {
        this._config.log( Config.CLASS_X2, 3 ) ? console.log( "X2.sessionCreated: loading services" ) : Config.NOP();

        var self = this, ready, setPc, setCc, onCcError, setResume, setFavorites, onFavoriteError, 
                setVod, onPcError, onResumeError, onVodError, token, summary, entitlements, 
                setDevicesList, onDeviceError;

        setCc = function( cc )
        {
            self._channelCollection = cc;
        };

        onCcError = function( error )
        {
            console.log( "ERROR -> unable to load channel collection" );
            //TODO: log error to telemetry?
            //TODO: retry logic?
        };

        setPc = function( pc )
        {
            self._pc = pc;
        };

        onPcError = function( error )
        {
            console.log( "ERROR -> unable to load parental controls" );
            self._pcError = error;
        };

        setFavorites = function( obj )
        {
            self._favorites = obj;
        };

        onFavoriteError = function( error )
        {
            self._favorites = new Favorites();
            console.log( error.toString() );
        };

        setResume = function( rp )
        {
            _x2._resume = rp;
        };

        onResumeError = function( error )
        {
            console.log(  "Resume api fails", error.toString() );
        };

        setVod = function( root )
        {
            self._vodRoot = root;
        };

        onVodError = function( error )
        {
            console.log( "ERROR -> unable to load VOD" );
            console.log( error );

            self._vodRootError = error;
        };

        setDevicesList = function(response) {
            console.log("Device API loaded");
            _x2._devicesList = new DevicesList(response);
        }

        onDeviceError = function() {
            //NOTE: If the getAllDevicesList query fails, we'll only fail to capture a value for _x2._metricsDeviceInfo. This is only used downstream for logging. Just carry on.
            console.log("Device API fails");
            _x2._devicesList = new DevicesList(null);//we should not block user with name device screen, we should still allow user to login into app.
        }

        ready = function()
        {
            console.log( "Intial api finish loaded in", ( new Date().getTime() - window.contentLoadTime)/ 1000);
            _x2._config._purchases = ( _x2._config._allowPurch === true && _x2._features.getFeature( "transactions" ) === "true" ) ? true : false;
            _x2._config._isSmbUser = _x2._features.getUserType() === "smb";

            if( self._pcError )
            {
                console.log( self._pcError );

                var onDismiss = function()
                {
                    self.sessionCreated();
                };

                _x2.pushOverlay( new ErrorOverlay().init( { error:self._pcError, context:ErrorOverlay.Context.COMMON, onDismiss:onDismiss } ) )
            }
            else if( _x2._showTerms !== true )
            {
                var currentDevice = _x2._devicesList && _x2._devicesList.getCurrentDevice();
                if( currentDevice ) {
                    _x2._metricsDeviceInfo = currentDevice;
                }
                if( _x2._devicesList && _x2._devicesList.isDataLoaded() === true && currentDevice === null ) {
                    console.log("Device is not associated with current user");//Logged to trace the workflow
                    _x2.setScreen( new DeviceNameScreen().init( { hideCancel:true, onChange:function() { _x2.setDefaultScreen(); } } ) );
                }
                else {
                    _x2.setDefaultScreen();
                }

            }
            else
                _x2.setScreen( new TermsScreen().init() );
        };

        // check device is in home and determine entitlements

        token        = Host.getLocalStorage( "XsctToken" );
        token        = token && JSON.parse( token );
        summary      = token.tokenSummary;
        entitlements = summary.entitlements;

        _x2._metricsSocket = new MetricsSocket( token );
        _x2._telemetry     = new Telemetry( token.tokenSummary.inHomeStatus );
        _x2._splunk        = new Splunk( token );

        console.log( "Device Id: " +_x2._metricsSocket._deviceId );
        console.log( "Intial api start loaded in", ( new Date().getTime() - window.contentLoadTime)/ 1000);
        document.querySelector('.initial-loading').style.display = 'none'; //hide initial loading div
        var university = summary.userType === "university" ? summary.partnerId : "None";
        var makeModel  = _x2._config._host._make ? (_x2._config._host._make + " " + _x2._config._host._product) : _x2._config._host._product;
        var userType   = _x2._features.getUserType() === "smb" ? "smb" : summary.userType;
        _x2.localyticsSetCustomDimension( X2.LocalyticsDimension.LOGGED_IN     , "Yes"                                             ); // Localytics
        _x2.localyticsSetCustomDimension( X2.LocalyticsDimension.CONNECTION    , X2.LocalyticsInHome      [ summary.inHomeStatus ] );
        _x2.localyticsSetCustomDimension( X2.LocalyticsDimension.UNIVERSITY    , university                                        );
        _x2.localyticsSetCustomDimension( X2.LocalyticsDimension.X1_USER_TYPE  , X2.LocalyticsUserType    [ userType             ] );
        _x2.localyticsSetCustomDimension( X2.LocalyticsDimension.ACCOUNT_STATUS, X2.LocalyticsAccountState[ summary.accountState ] || "None" );
        _x2.localyticsSetCustomDimension( X2.LocalyticsDimension.DEVICE_MODEL  , makeModel                                         );
        _x2.localyticsSetCustomDimension( X2.LocalyticsDimension.APP_VERSION   , AboutOverlay.version                              );

        if( window.ll )
            window.ll( "setCustomerId", summary.analyticsId );

        this._config.log( Config.CLASS_X2, 7 ) ? console.log( summary                             ) : Config.NOP();
        this._config.log( Config.CLASS_X2, 1 ) ? console.log( "IN HOME = " + summary.inHomeStatus ) : Config.NOP();

        var cdvr, est, clinear, cvod;

        // Features is the primary source of entitlements and session token is the fallback
        if( this._features.isDefined() )
        {
            est     = this._features.hasEntitlement( Features.Entitlement.EST      );
            cdvr    = this._features.hasEntitlement( Features.Entitlement.C_DVR    );
            clinear = this._features.hasEntitlement( Features.Entitlement.C_LINEAR );
            cvod    = this._features.hasEntitlement( Features.Entitlement.C_VOD    );
        }
        else if( entitlements )
        {
            for( var i = 0; i < entitlements.length; i++ )
            {
                switch( entitlements[i] )
                {
                    case "cdvr":
                        cdvr = true;
                        break;
                    case "clinear":
                        clinear = true;
                        break;
                    case "cvod":
                        cvod = true;
                        break;
                    case "est":
                        est = true;
                        break;
                }
            }
        }

        _x2._config._isCdvr    = cdvr;
        _x2._config._isEst     = est;
        _x2._config._isChurned = ( est && !cdvr && !clinear && !cvod );

        this._config.log( Config.CLASS_X2, 1 ) ? console.log( "IS CDVR = " + _x2._config._isCdvr ) : Config.NOP();
        this._config.log( Config.CLASS_X2, 1 ) ? console.log( "IS EST  = " + _x2._config._isEst  ) : Config.NOP();

        // load all services if allowed to proceed
        this._data._getCcPromise = undefined;
        if( _x2._config._isChurned )
        {
            console.log( "SKIPPING IN HOME SINCE CHURNED USER" );

            this._settings = new Settings();

            if( this._settings.getValue( Settings.Key.TERMS ) < Settings.TERMS_VERSION )
            {
                this._showTerms = true;
                this._settings.setValue( Settings.Key.TERMS, Settings.TERMS_VERSION );
            }

            var p = [];
            p.push( this._data.getParentalControls(true).then( setPc ).catch( onPcError ) );
            p.push( this._data.getResumePoints( null, true).then( setResume ).catch( onResumeError ) );
            p.push( this._data.getAllDeviceList(true).then( setDevicesList, onDeviceError ).catch( onDeviceError ) );
            Promise.all(p).then( ready );
        }
        else if( summary.inHomeStatus === "in-home" || this._config._skipInHome === true )
        {
            if( summary.isLinearEntitled && summary.isVODEntitled )
            {
                this._settings = new Settings();

                if( this._settings.getValue( Settings.Key.TERMS ) < Settings.TERMS_VERSION )
                {
                    this._showTerms = true;
                    this._settings.setValue( Settings.Key.TERMS, Settings.TERMS_VERSION );
                }

                var filters = _x2.getBrowseFilterString();

                var p = [];
                p.push( this._data.getParentalControls(true).then( setPc ).catch( onPcError ) );
                p.push( this._data.getResumePoints( null, true).then( setResume ).catch( onResumeError ) );
                p.push( this._data.getFavorites(true).then( setFavorites ).catch( onFavoriteError ) );
                p.push( this._data.getVodRoot(1,0,filters, true).then( setVod ).catch( onVodError ) );
                p.push( this._data.getChannelCollection(true).then( setCc ).catch( onCcError ) );
                p.push( this._data.getAllDeviceList(true).then( setDevicesList, onDeviceError ).catch( onDeviceError ) );
                Promise.all(p).then( ready );
            }
            else
                _x2.setScreen( new NotEntitledScreen().init() );
        }
        else
        {
            _x2._config._isSmbUser = _x2._features.getUserType() === "smb";
            _x2.pushOverlay( new InHomeFailOverlay().init() );
        }
    };

    X2.prototype.sessionNeedsCredentials = function( onAuth, params )  // TODO replace with login screens
    {
        var self = this;

        switch( this._config._authMode )
        {
            case Config.AUTH_CIMA:
                this._authService.sendCredentials( "Hawkins2015", "Comcast2015", onAuth );
                break;

            case Config.AUTH_CISCO_SAML:
                this._authService.sendCredentials( "sean.cox1", "c0xnetpass", onAuth );
                break;

            case Config.AUTH_OAUTH:
            case Config.AUTH_XTV:
                this.setScreen( new WelcomeScreen().init( onAuth, params ) );
                break;

            default:
                console.error( "ERROR -> unknown auth mode = " + self._config._authMode );
                break;
        }
    };

    X2.prototype.setDefaultScreen = function()
    {
        var screen, onEntity;
        var defaultScreen = this._config._initialScreen;

        if( this._tempDefaultScreen )
        {
            defaultScreen = this._tempDefaultScreen;
            this._tempDefaultScreen = undefined;
        }
        switch( defaultScreen )
        {
            case "browse":
                screen = new VodRootScreen().init();
                break;

            case "live":
                screen = new GuideScreen().init();
                break;

            case "mainMenu":
                if( _x2._config._isChurned === true )
                    screen = new ChurnedMainMenuScreen().init();
                else if( (this._config._purchases === true) && this._features.hasEntitlement( Features.Entitlement.EST ) && (_x2._settings.getValue( Settings.Key.PURCHASES ) !== true) )
                    screen = new PurchasesFtueScreen().init();
                else if( _x2._config._smartHubEntityId ) { //for debugging purpose
                    screen = new TransitionScreen().init( { entityId:  _x2._config._smartHubEntityId } ) ;
                } else
                    screen = new MainMenuScreen().init();
                break;

            case "saved":
                screen = new SavedScreen().init();
                break;

            case "search":
                screen = new SearchScreen().init();
                break;

            case "settings":
                screen = new SettingsScreen().init();
                break;

            case "test":
                screen = new TestScreen().init();
                break;

            default:
                _x2.setScreen( new TransitionScreen().init( { entityId:defaultScreen } ) );
                break;
        }

        if( screen )
            this.setScreen( screen );
    };

    X2.prototype.setOverlayRootLastFocus = function( widget )
    {
        this._overlayRoot._children[0]._lastFocus = widget;
    };

    X2.prototype.setScreen = function( screen )
    {
        console.log( screen._className, " loaded in " , (new Date().getTime() - window.contentLoadTime)/1000, " secs");
        this._overlayRoot.clear();
        this._screenRoot.set( screen );
    };

    /**
     * Check if the entity should be locked by PC and callback when validated (not PC'd or correct PIN entered)
     * @param entity
     * @return {Promise}
     */
    X2.prototype.checkParentalControls = function( showing, entity, channel, silent, speechStr )
    {
        var resolver = function( resolve )
        {
            var series, id, rating;

            if( showing )
            {
                id     = showing.getEntityId();
                rating = showing.getRating ? showing.getRating() : showing.getProgram().getRating();
            }

            var locked = _x2._pc.isRatingLocked( rating );

            if( ! locked )
                locked = _x2._pc.isTitleLocked( id );

            if( ! locked )
            {
                if( entity && entity.getSeries )
                {
                    series = entity.getSeries();
                    if( series )
                        locked = _x2._pc.isTitleLocked( series.getEntityId() );
                }
            }

            if( !locked && channel )
                locked = _x2._pc.isChannelLocked( channel.getId() );

            if( locked )
            {
                if( silent != true )
                {
                    var overlay, newOverlay, params = {};

                    var onValidatePin = function( validatePinStr )
                    {
                        if( _x2._pc.checkPin( validatePinStr ) === true )
                        {
                            _x2.popOverlay( overlay, resolve );
                        }
                        else
                        {
                            params.type      = PinOverlay.Type.PC_VALIDATE_FAIL;
                            params.speechStr = undefined;
                            _x2.pushOverlay( newOverlay = new PinOverlay().init( params ) );
                            _x2.popOverlay( overlay );
                            overlay = newOverlay;
                        }
                    };

                    params.type      = PinOverlay.Type.PC_VALIDATE;
                    params.onCapture = onValidatePin;
                    params.speechStr = speechStr;
                    _x2.pushOverlay( overlay = new PinOverlay().init( params ) );
                }
                else
                    resolve( true );
            }
            else
                resolve( false );
        };

        return new Promise( resolver );
    };

    /*
    *It will save last 10 key press or key down event in the array.
    *It will run only in tizen or webOS simulator.
    *If keyup is triggered before the key down event, then we will trigger the key down event manually */
    X2.prototype.pushIntoKeyEventHistory = function( event ) {
        var prevKeyEvent = this.keyEventHistory[0];//take previous key event, before insert
        if( this.keyEventHistory.length > 9 ) {
            this.keyEventHistory.pop();//Remove the last element
        }
        this.keyEventHistory.unshift({ 'keyEvent': event.actualEventType || event.type, 
        'keyCode': event.keyCode,
        'parentKeyType': event.parentType });
        if( !event.parentType && ( !prevKeyEvent ||
            ( event.type == 'keyup' && (prevKeyEvent.keyEvent == 'keyup' || prevKeyEvent.parentKeyType == 'keyup') ) )) {
                event.actualEventType = 'keydown';
                event.parentType = 'keyup';
                this.onKeyDown( event );
            }//if there is no key pressed and only key released event, then we need to triggered key_pressed event.
    }
    //it indicate whether cursor appear on TV or not
    X2.prototype.cursorVisibilityChange = function(event) {
        var visibility = event.detail.visibility;
        if( visibility ){
            console.log("Cursor appeared");
            _x2._config._cursorEnabled = true;
            _x2.enableAllClickEvents();
        }
        else{
            console.log("Cursor disappeared");
            _x2._config._cursorEnabled = false;
            _x2.disableAllClickEvents();
        }
      }

      X2.prototype.enableAllClickEvents = function() {
        var allElements = document.querySelectorAll('.customClickEvent') || [];
        allElements.forEach( function(element) {
            if( element.id.indexOf('OverlayRoot') > -1 ) {
                element.style.pointerEvents = 'none';
            }
            if( element.customClickEvent) {
                element.addEventListener('mousedown', element.customClickEvent);
            }
        });
      }

      X2.prototype.disableAllClickEvents = function() {
        var allElements = document.querySelectorAll('.customClickEvent') || [];
        allElements.forEach( function(element) {
            if( element.id.indexOf('OverlayRoot') > -1 ) {
                element.style.pointerEvents = 'auto';
            }
            if( element.customClickEvent ) {
                element.removeEventListener('mousedown', element.customClickEvent);
            }
        });
      }

    return X2;

})();
